import { useT } from "@/i18n/LangProvider";
import { useSwitchLang } from "@/i18n/routing";

export default function LanguageSwitcher({ dark = true }) {
  const { lang, langs } = useT();
  const switchLang = useSwitchLang();

  return (
    <div
      className="inline-flex items-center gap-1 border rounded-full p-1"
      style={{
        borderColor: dark
          ? "rgba(184, 150, 46, 0.35)"
          : "rgba(255,255,255,0.25)",
        background: dark ? "rgba(11,17,32,0.4)" : "transparent",
      }}
      data-testid="lang-switcher"
    >
      {langs.map((l) => {
        const active = l.code === lang;
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => switchLang(l.code)}
            data-testid={`lang-btn-${l.code}`}
            aria-label={l.full}
            className="font-mono-brand text-[0.65rem] px-2.5 py-1 rounded-full transition-colors"
            style={{
              color: active ? "var(--navy-deep)" : "var(--muted-white)",
              background: active ? "var(--gold-light)" : "transparent",
              letterSpacing: "0.14em",
              fontWeight: active ? 700 : 500,
            }}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
}
